import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { AgencyShortDataModel } from 'src/types';

type AgenciesResponse = {
  agencies: AgencyShortDataModel[];
  connectedAgencies: string[];
};

export const useDashboardFetchAllAgencies = () => {
  const { data, isLoading, error, fetcher } = useFetcher<AgenciesResponse | null>(null);

  const fetchAllAgencies = useCallback(() => {
    fetcher(EndPoints.getDashboardAgencies, {
      requiredToken: true,
      method: 'GET',
    });
  }, [fetcher]);

  return {
    agencies: data?.agencies ?? [],
    isLoading,
    connectedAgencies: data?.connectedAgencies ?? [],
    error,
    fetchAllAgencies,
  };
};
